import React from 'react';
import Select from '../Select/Select';

const options = [
  { value: true, label: 'ÐÐ°' },
  { value: false, label: 'ÐÐµÑ' },
];

const SelectStockCar = ({ ...props }) => {
  return <Select options={options} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectStockCar;
